/**
 * Directional drift up gesture
 * @module gestures/effects/driftUp
 */
import { createDriftGesture } from './driftFactory.js';
export default createDriftGesture('up');
